"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base");
var Line = /** @class */ (function (_super) {
    __extends(Line, _super);
    function Line() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._reservedAttr = ["x1", "y1", "x2", "y2"];
        return _this;
    }
    Line.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_from":
            case "_to":
                return value.split(",").map(function (x) { return parseInt(x, 10); });
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    Line.prototype.renderElement = function (node, d, i, g) {
        node.attr("x1", this._getGeometry("x1", true, d, i, g))
            .attr("y1", this._getGeometry("y1", false, d, i, g))
            .attr("x2", this._getGeometry("x2", true, d, i, g))
            .attr("y2", this._getGeometry("y2", false, d, i, g));
    };
    Line.nodeName = "line";
    return Line;
}(base_1.BaseElement));
exports.Line = Line;
//# sourceMappingURL=line.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/element/line.js
// module id = 1134
// module chunks = 0 1